import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskProjectDashboardsEditableRoute: InvariantJiraRoute = {
	name: 'servicedesk-avp-project-dashboards-editable',
	path: '/jira/servicedesk/projects/:projectKey/dashboards/:dashboardId',
};
